import React from "react";
import Layout from "./Layout";

const StepLayout = ({ draggedAttributeId, onDropAttribute }) => {

    return (
        <div className="form-builder-step-layout">
            <Layout draggedAttributeId={draggedAttributeId} onDropAttribute={onDropAttribute} />
        </div>
    );
}

export default StepLayout;